import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, useMediaQuery, useTheme } from '@mui/material';

import { styled } from '@mui/material/styles';
import OrderSummary from '../order-summary/OrderSummary';

const Details = styled(Box)({
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  scrollbarWidth: 'none',
  transition: '0.5s ease-in-out',
});

const DetailsPanel = ({
  affiliateOptions,
  affiliates,
  chainContactIds,
  currentAffiliate,
  currentLocation,
  currentProduct,
  data,
  originatorLocationProductOrigins,
}) => {
  const [detailsExpanded, setDetailsExpanded] = useState(false);
  const theme = useTheme();
  const xs = useMediaQuery(theme.breakpoints.only('xs'), { noSsr: true });

  const handleHeaderClick = () => setDetailsExpanded(!detailsExpanded);
  const modifiedContactIds = [];
  if (chainContactIds) {
    chainContactIds.forEach(id => {
      const chainContact = affiliateOptions.find(({ value }) => value === id.toString());
      const name = chainContact.label;
      modifiedContactIds.push({ id, name });
    });
  }
  return (
    <>
      <Details
        alignItems="flex-start"
        bgcolor="graphic.lighter"
        borderTop={`0.1em solid ${theme.palette.graphic.light}`}
        bottom={68}
        display="flex"
        flexDirection="column"
        height={detailsExpanded ? `calc(100% - 86px - 66px)` : '48px'}
        justifyContent={detailsExpanded ? 'unset' : 'space-between'}
        overflow={detailsExpanded ? 'visible overlay' : 'visible hidden'}
        position="fixed"
        width={xs ? '100%' : `390px`}
        zIndex={10}
      >
        <OrderSummary
          chainContactIds={modifiedContactIds}
          createPtoData={data}
          currentAffiliate={currentAffiliate}
          currentLocation={currentLocation}
          currentProduct={currentProduct}
          detailsExpanded={detailsExpanded}
          headerButton
          headerTitle="Order Summary"
          onHeaderClick={handleHeaderClick}
          originatorLocationProductOrigins={originatorLocationProductOrigins}
          userAffiliates={affiliates}
        />
      </Details>
    </>
  );
};

DetailsPanel.propTypes = {
  affiliateOptions: PropTypes.arrayOf(PropTypes.shape({})),
  affiliates: PropTypes.arrayOf(PropTypes.shape({})),
  chainContactIds: PropTypes.arrayOf(PropTypes.number),
  currentAffiliate: PropTypes.shape({}),
  currentLocation: PropTypes.shape({}),
  currentProduct: PropTypes.shape({}),
  data: PropTypes.shape({}).isRequired,
  originatorLocationProductOrigins: PropTypes.arrayOf(PropTypes.shape({})),
};

DetailsPanel.defaultProps = {
  affiliateOptions: [],
  affiliates: [],
  chainContactIds: [],
  currentAffiliate: {},
  currentLocation: {},
  currentProduct: {},
  originatorLocationProductOrigins: [],
};
export default DetailsPanel;
